import { Schema } from "@bumi/core/schema"
import { createContext, useContext } from "solid-js"

export const SchemaContext = createContext<Schema.Info>()

export function useSchemaContext() {
  const schema = useContext(SchemaContext)
  return schema!
}
